module.exports = __webpack_public_path__ + "img/exemplo.57073eb8.jpg";